import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0xcAD001c30E96765aC90307669d578219D4fb1DCe": "Euler DAO Multisig",
        "0x35400831044167E9E2DE613d26515eeE37e30a1b":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0x35400831044167E9E2DE613d26515eeE37e30a1b":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0x184d597Be309e11650ca6c935B483DcC05551578": "Re7 Labs Euler Multisig",
        "0x8378f03722Ca0b9939Be4bEaEf0BF64c0062f232": "Re7 Labs Euler Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "apostro",
    {
      name: "Apostro",
      logo: "entities/apostro.png",
      description:
        "Building a better way to self-regulate markets to avoid oracle attacks.",
      url: "https://www.apostro.xyz/",
      addresses: {
        "0x05591B3aFE2239Ff3669BCfD715815d2ba8A24a4": "Apostro Timelock",
        "0xf726311F85D45a7fECfFbC94bD8508a0A39958c6": "Apostro Multisig",
      },
      social: { twitter: "apostroxyz" },
    },
  ],
  [
    "alterscope",
    {
      name: "Alterscope",
      logo: "entities/alterscope_wb.png",
      description:
        "Alterscope provides the platform for processing and modelling risk in real-time across chains, protocols, and liquidity pools.",
      url: "https://www.alterscope.org/",
      addresses: {
        "0x2e571f334fe06A6a2741dd0E4cb5Bc7C1F8Af808": "Alterscope Multisig",
      },
      social: { twitter: "Alterscope" },
    },
  ],
  [
    "dinero",
    {
      name: "Dinero",
      logo: "entities/dinero.png",
      description:
        "The yield baseplate of Ethereum. Providing a suite of products that scale yield for protocols and users.",
      addresses: {
        "0x66301F68E8EdE19C0EcD1AB0b3Ee6FdE9cb143Fb":
          "Dinero Protocol Timelock Controller",
      },
    },
  ],
  [
    "idle",
    {
      name: "Idle DAO",
      logo: "entities/idle.png",
      description:
        "Idle DAO empowers the DeFi market with robust yield automation and hedging instruments, facilitating its expansion and establishing the foundation for a sustainable credit financial ecosystem via a more efficient and risk-adjusted capital allocation.",
      url: "https://idle.finance/",
      addresses: {
        "0xFb3bD022D5DAcF95eE28a6B07825D4Ff9C5b3814": "Idle DAO Multisig",
        "0xF02Faf7CFEe786111eaE6747a0c344b48C1eD5E5":
          "Idle DAO Limited Governor",
      },
      social: { twitter: "idlefinance" },
    },
  ],
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0x38afC3aA2c76b4cA1F8e1DabA68e998e1F4782DB": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
  [
    "k3",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0xdD84A24eeddE63F10Ec3e928f1c8302A47538b6B": "K3 Capital Multisig",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "swaap-labs",
    {
      name: "Swaap labs",
      logo: "entities/swaap.png",
      description:
        "Swaap Labs builds and operates onchain financial primitives, with a special focus on risk management and onchain market making",
      url: "https://www.swaap.finance/",
      addresses: {
        "0xD6Ff6aBb93EF058A474769f0d05C7fEF440920F8": "Swaap Multisig",
      },
      social: { twitter: "@SwaapFinance" },
    },
  ],
  [
    "tulipa-capital",
    {
      name: "Tulipa Capital",
      logo: "entities/tulipacapital.png",
      description:
        "At Tulipa Capital, we leverage cutting-edge technology and innovative financial strategies to maximize yields while implementing rigorous risk management practices.",
      url: "https://www.tulipa.capital/",
      addresses: {
        "0xF53eAeB7e6f15CBb6dB990eaf2A26702e1D986d8": "Tulipa Capital Multisig",
        "0x2D10ae93c6BF868556aE9577aD0e8b24004aB816": "Tulipa Capital Timelock",
      },
      social: { twitter: "tulipacapital" },
    },
  ],
  [
    "usual",
    {
      name: "Usual",
      logo: "entities/usual.svg",
      description:
        "Usual is a decentralized finance framework centered around USD0, a stablecoin designed as a liquid deposit token. It embodies the principle of redistributing value generated by users through a revenue-based token, USUAL. This approach enables users to access yields while simultaneously gaining exposure to the protocol's growth and long-term success.",
      url: "https://www.usual.money/",
      addresses: {
        "0xdd82875f0840AAD58a455A70B88eEd9F59ceC7c7":
          "Usual Collateral Treasury",
        "0x81ad394C0Fa87e99Ca46E1aca093BEe020f203f4": "Usual Yield Treasury",
        "0xF3D913De4B23ddB9CfdFAF955BAC5634CbAE95F4": "Longterm Treasury",
      },
      social: {
        twitter: "usualmoney",
        discord: "hhttps://discord.usual.money/",
        telegram: "https://t.me/UsualCommunity",
      },
    },
  ],
  [
    "ouroboros-capital",
    {
      name: "Ouroboros Capital",
      logo: "entities/ouroboroscap.png",
      description:
        "Ouroboros Capital curates yield strategies through rigorous risk management and in-depth market analysis to optimize risk-adjusted returns.",
      url: "https://www.ourocap.io/",
      addresses: {
        "0x8B5EB629Dc1d56B101cD340CA87Ea2506c551379":
          "Ouroboros Capital Multisig",
      },
      social: { twitter: "OuroborosCap8" },
    },
  ],
  [
    "zerolend",
    {
      name: "ZeroLend",
      logo: "entities/zerolend.jpg",
      description:
        "ZeroLend is a decentralized lending market curating vaults for LRTs, Real World Assets (RWAs), BTCFi, and promising tokens.",
      url: "https://zerolend.xyz/",
      addresses: {
        "0x54061E18cd88D2de9af3D3D7FDF05472253B29E0": "ZeroLend Multisig",
        "0x1f4817b5F2B2e71658251d905634C62FAb8e2033":
          "ZeroLend/Rezerve Multisig",
      },
      social: { twitter: "zerolendxyz" },
    },
  ],
  [
    "keyring",
    {
      name: "Keyring",
      logo: "entities/keyring.svg",
      description: "Enhanced depositor protection with instant zkVerification.",
      url: "https://keyring.network/",
      addresses: {
        "0x69cC425B1E5f302e7Db4E5d125ab984EC5186364": "Keyring Multisig",
      },
      social: { twitter: "keyringnetwork", github: "keyring-network" },
    },
  ],
  [
    "telosc",
    {
      name: "TelosC",
      logo: "entities/telosc.svg",
      description:
        "Engineered growth for crypto. Incentives, risk frameworks, and GTM for DeFi. Driving real users, TVL & revenue.",
      url: "https://telosc.com/",
      addresses: {
        "0x7d07BFdd01422D7b655B333157eB551B9712dCd8": "TelosC Multisig",
      },
      social: { twitter: "TelosConsilium" },
    },
  ],
  [
    "clearstar",
    {
      name: "Clearstar",
      logo: "entities/clearstar.svg",
      description:
        "Designing and curating institutional-grade strategies across decentralized markets, underpinned by rigorous risk management.",
      url: "https://www.clearstar.xyz/",
      addresses: {
        "0x30988479C2E6a03E7fB65138b94762D41a733458":
          "Curator Wallet 1 (ForDeFi MPC)",
        "0x72882eb5D27C7088DFA6DDE941DD42e5d184F0ef":
          "Curator Wallet 2 (ForDeFi MPC)",
      },
      social: { twitter: "ClearstarLabs" },
    },
  ],
  [
    "tidcapital",
    {
      name: "TID Capital",
      logo: "entities/TIDCapProfile.png",
      description: "Research Driven Farming and Trading arm of Today in DeFi",
      url: "https://tid.capital",
      addresses: {
        "0x0dc6598fA1D16e6650D4673bf8Aac6b42e72527F": "TID Capital Multisig",
      },
      social: { twitter: "tidcapital" },
    },
  ],
  [
    "sentora",
    {
      name: "Sentora",
      logo: "entities/sentora.svg",
      description:
        "Sentora provides the institutional-grade foundation for powering the next generation of DeFi solutions. Sentora's vault platform unlocks access to DeFi through sophisticated strategies, robust risk management, and enterprise-grade security.",
      url: "https://sentora.com/platform/defi-strategies",
      addresses: {
        "0x9453ee262d7C95955e690AE7aBBD82a08B135685":
          "Sentora Vault Access Control Governor",
        "0xFe69A4B5dc5cf0E1DC1B5De37EfbA5E55131c660": "Sentora Multisig",
        "0x384ce10D6E54dc6A641784E7F0EA4286fccC1Ea7": "Sentora MPC Wallet",
      },
      social: { twitter: "SentoraHQ" },
    },
  ],
  [
    "hyperithm",
    {
      name: "Hyperithm",
      logo: "entities/hyperithm.png",
      description:
        "Hyperithm maximizes yield by swiftly integrating unique collaterals, providing borrowers with high-return opportunities through active optimization while ensuring effective risk management.",
      url: "https://www.hyperithm.com/",
      addresses: {
        "0x75178137D3B4B9A0F771E0e149b00fB8167BA325": "Hyperithm MPC wallet",
        "0xEe7E9bb21D5589BF657b94083dB2fA349a3918C8": "Hyperithm Multisig",
      },
      social: { twitter: "hyperithm" },
    },
  ],
  [
    "9summits",
    {
      name: "9 Summits",
      logo: "entities/9summits.png",
      description:
        "By curating top-performing vaults, we empower our clients to access the best opportunities in decentralized finance with confidence and precision.",
      url: "https://9summits.io/",
      addresses: {
        "0x23E6aecB76675462Ad8f2B31eC7C492060c2fAEF":
          "9 Summits vault Admin Multisig",
      },
      social: { twitter: "nine_summits" },
    },
  ],
  [
    "yieldnest",
    {
      name: "YieldNest",
      logo: "entities/yieldnest.svg",
      description:
        "YieldNest - Simple. Secure. Supercharged Yield protocol. Fine tunes and curates vaults across Defi to offer the best risk-adjusted returns.",
      url: "https://yieldnest.finance/",
      addresses: {
        "0xfcad670592a3b24869C0b51a6c6FDED4F95D6975":
          "YieldNest YnSecurityCouncil Multisig",
      },
      social: { twitter: "yieldnestfi" },
    },
  ],
])
